import { capitalize } from "src/utils/string_helpers"

export const importStatusLabel = (status) =>
  status === "completed" ? "Imported" : capitalize(status)
